module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Enquiry Form - " + _vm._s(_vm.EnqNo))]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [_c('FilterCBModal'), _vm._v(" "), (!_vm.EnqNo) ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "info"
    },
    on: {
      "click": _vm.goToDomestic
    }
  }, [_vm._v("Generate Domestic Enquiry")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "90",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    staticClass: "mt-2 mr-3",
    attrs: {
      "for": "jobType"
    }
  }, [_vm._v("Job Type *")]), _vm._v(" "), _vm._l((_vm.showSegmentArray), function(segmentNameArray, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": segmentNameArray.flex,
        "md-flex-small": "100"
      }
    }, [_c('md-checkbox', {
      staticClass: "md-primary",
      attrs: {
        "md-value": segmentNameArray.value,
        "name": 'jobType' + (index + 1),
        "id": 'jobType' + (index + 1),
        "disabled": _vm.disbleEnquiry
      },
      on: {
        "change": function($event) {
          _vm.jobTypeSelect(segmentNameArray.value, index)
        }
      },
      model: {
        value: (_vm.ffExoprtDetail.jobType[index]),
        callback: function($$v) {
          _vm.$set(_vm.ffExoprtDetail.jobType, index, $$v)
        },
        expression: "ffExoprtDetail.jobType[index]"
      }
    }), _vm._v(" "), _c('h6', {
      staticStyle: {
        "margin-top": "17px"
      }
    }, [_c('b-badge', {
      attrs: {
        "variant": "light"
      }
    }, [_vm._v(_vm._s(segmentNameArray.show))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), (
    _vm.ffExoprtDetail.selectedFFQuotationId != '' ||
    _vm.ffExoprtDetail.selectedCCQuotationId != '' ||
    _vm.ffExoprtDetail.selectedTPTQuotationId != ''
  ) ? _c('b-card', {
    staticStyle: {
      "background": "whiteSmoke"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.ffExoprtDetail.selectedFFQuotationId != '') ? _c('md-layout', {
    attrs: {
      "md-flex": "25",
      "md-flex-small": "100"
    }
  }, _vm._l((_vm.showFFSelectedExistQ), function(itemFF, index) {
    return _c('div', {
      key: index
    }, [_c('h6', [_c('b-badge', {
      attrs: {
        "variant": "info"
      }
    }, [_vm._v("Selected Existing Freight Quotation")])], 1), _vm._v(" "), (itemFF.shipmentType == '1') ? _c('div', [_c('b', [_vm._v("Container Type :")]), _vm._v("\n                      " + _vm._s(itemFF.multipleContainerType) + "\n                      "), _c('br'), _vm._v(" "), _c('b', [_vm._v("POR :")]), _vm._v("\n                      " + _vm._s(itemFF.POR) + "\n                      "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Load Port :")]), _vm._v("\n                      " + _vm._s(itemFF.LP) + "\n                      "), _c('br'), _vm._v(" "), _c('b', [_vm._v("POD :")]), _vm._v("\n                      " + _vm._s(itemFF.POD) + "\n                      "), _c('br'), _vm._v(" "), _c('b', [_vm._v("FPOD :")]), _vm._v("\n                      " + _vm._s(itemFF.finalPlace) + "\n                    ")]) : _c('div', [_c('br'), _vm._v(" "), _c('b', [_vm._v("Departure Airport :")]), _vm._v("\n                      " + _vm._s(itemFF.departPort) + "\n                      "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Destination Airport :")]), _vm._v("\n                      " + _vm._s(itemFF.destiPort) + "\n                    ")]), _vm._v(" "), _c('br'), _vm._v(" "), (
      itemFF.ffQuotationPdf != '' && itemFF.ffQuotationPdf != null
    ) ? _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "outline-success"
      },
      on: {
        "click": function($event) {
          _vm.PrintFF(itemFF.ffQuotationPdf)
        }
      }
    }, [_vm._v("View Quotation")]) : _vm._e()], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.ffExoprtDetail.selectedCCQuotationId != '') ? _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.ffExoprtDetail.selectedCCQuotationId != '') ? _c('md-layout', {
    attrs: {
      "md-flex": "25",
      "md-flex-small": "100"
    }
  }, _vm._l((_vm.showCCSelectedExistQ), function(itemCC, index2) {
    return _c('div', {
      key: index2
    }, [_c('h6', [_c('b-badge', {
      attrs: {
        "variant": "info"
      }
    }, [_vm._v("Selected Existing Custom Quotation")])], 1), _vm._v(" "), _c('b', [_vm._v("Container Type :")]), _vm._v("\n                    " + _vm._s(itemCC.multipleContainerType) + "\n                    "), _c('br'), _vm._v(" "), _c('b', [_vm._v("POR :")]), _vm._v("\n                    " + _vm._s(itemCC.POR) + "\n                    "), _c('br'), _vm._v(" "), (
      itemCC.ccQuotationPdf != '' && itemCC.ccQuotationPdf != null
    ) ? _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "outline-success"
      },
      on: {
        "click": function($event) {
          _vm.PrintCC(itemCC.ccQuotationPdf)
        }
      }
    }, [_vm._v("View Quotation")]) : _vm._e()], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.ffExoprtDetail.selectedTPTQuotationId != '') ? _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.ffExoprtDetail.selectedTPTQuotationId != '') ? _c('md-layout', {
    attrs: {
      "md-flex": "25",
      "md-flex-small": "100"
    }
  }, _vm._l((_vm.showTPTSelectedExistQ), function(itemTPT, index) {
    return _c('div', {
      key: index
    }, [_c('h6', [_c('b-badge', {
      attrs: {
        "variant": "info"
      }
    }, [_vm._v("Selected Existing TPT Quotation")])], 1), _vm._v(" "), _c('b', [_vm._v("Container Type :")]), _vm._v("\n                    " + _vm._s(itemTPT.multipleContainerType) + "\n                    "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Pickup Location :")]), _vm._v("\n                    " + _vm._s(itemTPT.pickUp) + "\n                    "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Handover Location :")]), _vm._v("\n                    " + _vm._s(itemTPT.handover) + "\n                    "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Factory Location :")]), _vm._v("\n                    " + _vm._s(itemTPT.factoryLoc) + "\n                    "), _c('br'), _vm._v(" "), (
      itemTPT.tptQuotationPdf != '' && itemTPT.tptQuotationPdf != null
    ) ? _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "outline-success"
      },
      on: {
        "click": function($event) {
          _vm.PrintTPT(itemTPT.tptQuotationPdf)
        }
      }
    }, [_vm._v("View Quotation")]) : _vm._e()], 1)
  })) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "25",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Client Type *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.disbleEnquiry,
      "list": _vm.clientTypeList,
      "id": "clientNamenew",
      "option-value": "val",
      "option-text": "type",
      "placeholder": "Client Type"
    },
    on: {
      "input": _vm.fetchType
    },
    model: {
      value: (_vm.ffExoprtDetail.clientType),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "clientType", $$v)
      },
      expression: "ffExoprtDetail.clientType"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.clientType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.clientTypeError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Shipping Type *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.disbleEnquiry,
      "list": _vm.shipmentTypeList,
      "option-value": "shipmentTypeVal",
      "option-text": "shipmentTypeText",
      "placeholder": "Select Shipment Type"
    },
    on: {
      "input": _vm.getDataLocations
    },
    model: {
      value: (_vm.ffExoprtDetail.shipmentType),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "shipmentType", $$v)
      },
      expression: "ffExoprtDetail.shipmentType"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.shipmentType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.shipmentTypeError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "20",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Export / Import *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.disbleEnquiry || _vm.ffExoprtDetail.shipmentType == '',
      "list": _vm.transportTypeName,
      "option-value": "transportTypeVal",
      "option-text": "transportTypeText",
      "placeholder": "Select"
    },
    on: {
      "input": function($event) {
        _vm.getDataLocations()
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.transportType),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "transportType", $$v)
      },
      expression: "ffExoprtDetail.transportType"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.transportType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.transportTypeError))]) : _vm._e()], 1), _vm._v(" "), (_vm.ffExoprtDetail.clientType != '2') ? _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Client Name *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.disbleEnquiry ||
        _vm.ffExoprtDetail.shipmentType == '' ||
        _vm.ffExoprtDetail.transportType == '',
      "list": _vm.getCLientData,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Existing Client Name"
    },
    on: {
      "input": _vm.getClientFactoryLoc
    },
    model: {
      value: (_vm.ffExoprtDetail.clientId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "clientId", $$v)
      },
      expression: "ffExoprtDetail.clientId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.clientId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.clientIdError))]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (_vm.ffExoprtDetail.clientId && !_vm.ffExoprtDetail.mainEnquiryId) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Client Email & State")]), _vm._v(" "), _c('b-textarea', {
    attrs: {
      "id": "newClientAddress",
      "name": "newClientAddress",
      "type": "text"
    },
    model: {
      value: (_vm.clientIntro),
      callback: function($$v) {
        _vm.clientIntro = $$v
      },
      expression: "clientIntro"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.ffExoprtDetail.clientType == '2') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Lead Name *")]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-1",
    attrs: {
      "list": _vm.$store.getters['common/getAllLeadCompList'],
      "id": "newClientName",
      "option-value": "lead_comp_name",
      "option-text": "lead_comp_name",
      "placeholder": "Select Lead Name"
    },
    on: {
      "input": function($event) {
        _vm.LeadClientDetails()
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.newClientName),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "newClientName", $$v)
      },
      expression: "ffExoprtDetail.newClientName"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.newClientName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.newClientNameError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Client Email *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "newClientEmail",
      "name": "newClientEmail"
    },
    model: {
      value: (_vm.ffExoprtDetail.newClientEmail),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "newClientEmail", $$v)
      },
      expression: "ffExoprtDetail.newClientEmail"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.newClientEmail) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.newClientEmailError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Contact No. *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "newClientPhoneNumber",
      "name": "newClientPhoneNumber",
      "type": "text"
    },
    model: {
      value: (_vm.ffExoprtDetail.newClientPhoneNumber),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "newClientPhoneNumber", $$v)
      },
      expression: "ffExoprtDetail.newClientPhoneNumber"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.newClientPhoneNumber) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.newClientPhoneNumberError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Client Address *")]), _vm._v(" "), _c('b-textarea', {
    attrs: {
      "id": "newClientAddress",
      "name": "newClientAddress",
      "type": "number"
    },
    model: {
      value: (_vm.ffExoprtDetail.newClientAddress),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "newClientAddress", $$v)
      },
      expression: "ffExoprtDetail.newClientAddress"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.newClientAddress) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.newClientAddressError))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.ffExoprtDetail.shipmentType == '1') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.hideCContatiner == false) ? _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "AutoContainerType"
    }
  }, [_vm._v("Container Type *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.disbleEnquiry ||
        (_vm.ffExoprtDetail.shipmentType == '1' &&
          _vm.ffExoprtDetail.multipleContainerType[0] == 'LCL Container') ?
        true :
        false,
      "list": _vm.getContainerTypeData,
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "placeholder": "Select Container Type"
    },
    model: {
      value: (_vm.AutoContainerType),
      callback: function($$v) {
        _vm.AutoContainerType = $$v
      },
      expression: "AutoContainerType"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.ffExoprtDetail.multipleContainerType.length > 0) ? _c('md-layout', {
    attrs: {
      "md-flex": "70",
      "md-flex-small": "100"
    }
  }, _vm._l((_vm.ffExoprtDetail.multipleContainerType), function(type, index) {
    return _c('md-chip', {
      key: index,
      staticStyle: {
        "margin-top": "38px"
      },
      attrs: {
        "disabled": _vm.disbleEnquiry,
        "md-deletable": ""
      },
      on: {
        "delete": function($event) {
          _vm.deleteContainer(type)
        }
      }
    }, [_vm._v(_vm._s(type))])
  })) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "commodityType"
    }
  }, [_vm._v("Commodity Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.commodityTypeName,
      "option-value": "commodityTypeVal",
      "option-text": "commodityTypeText",
      "placeholder": "Select Commodity Type"
    },
    model: {
      value: (_vm.ffExoprtDetail.commodityType),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "commodityType", $$v)
      },
      expression: "ffExoprtDetail.commodityType"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.commodityType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.commodityTypeError))]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.ffExoprtDetail.commodityType == 'Hazardous') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("IMDG Class")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "IMDGClass",
      "name": "IMDGClass"
    },
    model: {
      value: (_vm.ffExoprtDetail.IMDGClass),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "IMDGClass", $$v)
      },
      expression: "ffExoprtDetail.IMDGClass"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("UN Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "UNNumber",
      "name": "UNNumber"
    },
    model: {
      value: (_vm.ffExoprtDetail.UNNumber),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "UNNumber", $$v)
      },
      expression: "ffExoprtDetail.UNNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Packing Code")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "packingCode",
      "name": "packingCode"
    },
    model: {
      value: (_vm.ffExoprtDetail.packingCode),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "packingCode", $$v)
      },
      expression: "ffExoprtDetail.packingCode"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.ffExoprtDetail.commodityType == 'Reefer') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Temperature Req(Degree Celsius)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "temperatureRequired",
      "name": "temperatureRequired"
    },
    model: {
      value: (_vm.ffExoprtDetail.temperatureRequired),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "temperatureRequired", $$v)
      },
      expression: "ffExoprtDetail.temperatureRequired"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.ffExoprtDetail.commodityType == 'Others') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Specific Detail if any..!")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "otherComodity",
      "name": "otherComodity"
    },
    model: {
      value: (_vm.ffExoprtDetail.otherComodity),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "otherComodity", $$v)
      },
      expression: "ffExoprtDetail.otherComodity"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.hideTPTSection == false) ? _c('div', {
    staticClass: "accordion mt-1",
    attrs: {
      "role": "tablist"
    }
  }, [_c('b-collapse', {
    attrs: {
      "id": "accordion-1",
      "visible": _vm.ffExoprtDetail.mainEnquiryId != '' ? true : _vm.showTPTAccordian,
      "accordion": "my-accordion1",
      "role": "tabpanel"
    }
  }, [_c('div', [(_vm.hideTPTSection == false) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "AutoPickupLocation"
    }
  }, [_vm._v(_vm._s(_vm.newJobType.indexOf("TPT") >= 0 ?
    "Pickup Location *" :
    "Pickup Location"))]), _vm._v(" "), (
    _vm.ffExoprtDetail.shipmentType == '1' &&
    _vm.ffExoprtDetail.transportType == 'Export' &&
    _vm.ffExoprtDetail.multipleContainerType[0] == 'LCL Container' &&
    _vm.newJobType.indexOf('TPT') >= 0
  ) ? _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.ffExoprtDetail.shipmentType == '1' &&
        _vm.ffExoprtDetail.transportType == 'Export' &&
        _vm.ffExoprtDetail.multipleContainerType[0] == 'LCL Container' &&
        _vm.newJobType.indexOf('TPT') >= 0 ?
        true :
        false,
      "id": "down2",
      "list": _vm.allLocationListFactory,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": _vm.allLocationList.length > 0 ?
        'Select Pickup Location' :
        'No Pickup Location'
    },
    on: {
      "input": function($event) {
        _vm.getLocationList(
          $event,
          'Client_Factory',
          'getAlllocationListDataFactory'
        )
      },
      "searchchange": function($event) {
        _vm.getLocationList(
          $event,
          'Client_Factory',
          'getAlllocationListDataFactory'
        )
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.pickupLocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "pickupLocationId", $$v)
      },
      expression: "ffExoprtDetail.pickupLocationId"
    }
  }) : (_vm.ffExoprtDetail.shipmentType == '1') ? _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.disbleEnquiry,
      "list": _vm.allLocationList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Pickup Location"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList(
          $event,
          'Icd,Sea_Port_India',
          'getAlllocationListData'
        )
      },
      "searchchange": function($event) {
        _vm.getLocationList(
          $event,
          'Icd,Sea_Port_India',
          'getAlllocationListData'
        )
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.pickupLocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "pickupLocationId", $$v)
      },
      expression: "ffExoprtDetail.pickupLocationId"
    }
  }) : _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": _vm.disbleEnquiry,
      "id": "transporterName",
      "name": "transporterName"
    },
    model: {
      value: (_vm.ffExoprtDetail.airPickup),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "airPickup", $$v)
      },
      expression: "ffExoprtDetail.airPickup"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.pickupLocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.pickupLocationIdError))]) : _vm._e()], 1), _vm._v(" "), (_vm.ffExoprtDetail.shipmentType == '1') ? _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "AutohandupLocation"
    }
  }, [_vm._v(_vm._s(_vm.newJobType.indexOf("TPT") >= 0 ?
    "Handover Location *" :
    "Handover Location "))]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.disbleEnquiry,
      "list": _vm.handoverListData,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Handover Location"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList(
          $event,
          'Icd,Sea_Port_India',
          'handoverListData'
        )
      },
      "searchchange": function($event) {
        _vm.getLocationList(
          $event,
          'Icd,Sea_Port_India',
          'handoverListData'
        )
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.handoverLocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "handoverLocationId", $$v)
      },
      expression: "ffExoprtDetail.handoverLocationId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.handoverLocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.handoverLocationIdError))]) : _vm._e()], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.hideTPTSection == false) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [(
    _vm.hideTPTSection == false && _vm.ffExoprtDetail.shipmentType == '1'
  ) ? _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "AutoStuffingLocation"
    }
  }, [_vm._v(_vm._s(_vm.newJobType.indexOf("TPT") >= 0 ?
    "Factory Location *" :
    "Factory Location "))]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "id": "down2",
      "isDisabled": _vm.disbleEnquiry,
      "list": _vm.allLocationListFactory,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": _vm.allLocationList.length > 0 ?
        'Select Factory Location' :
        'No Factory'
    },
    on: {
      "input": function($event) {
        _vm.getLocationList(
          $event,
          'Client_Factory',
          'getAlllocationListDataFactory'
        );
        _vm.ffExoprtDetail.shipmentType == '1' &&
          _vm.ffExoprtDetail.transportType == 'Export' &&
          _vm.ffExoprtDetail.multipleContainerType[0] == 'LCL Container' &&
          _vm.newJobType.indexOf('TPT') >= 0 ?
          _vm.FactoryPickupSame(_vm.ffExoprtDetail.stuffingLocationId) :
          '';
      },
      "searchchange": function($event) {
        _vm.getLocationList(
          $event,
          'Client_Factory',
          'getAlllocationListDataFactory'
        )
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.stuffingLocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "stuffingLocationId", $$v)
      },
      expression: "ffExoprtDetail.stuffingLocationId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.stuffingLocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.stuffingLocationIdError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "ccType"
    }
  }, [_vm._v("TPT Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.disbleEnquiry,
      "list": _vm.cctypeList,
      "option-value": "ccTypeVal",
      "option-text": "ccTypeTxt",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.ffExoprtDetail.tptType),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "tptType", $$v)
      },
      expression: "ffExoprtDetail.tptType"
    }
  })], 1), _vm._v(" "), (_vm.ffExoprtDetail.tptType == '2') ? _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Transporter Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": _vm.disbleEnquiry,
      "id": "transporterName",
      "name": "transporterName"
    },
    model: {
      value: (_vm.ffExoprtDetail.transporterName),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "transporterName", $$v)
      },
      expression: "ffExoprtDetail.transporterName"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.hideTPTSection == false) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "100",
      "md-flex-small": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("ON ACCOUNT OF")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": _vm.disbleEnquiry,
      "id": "onAccountOf",
      "name": "onAccountOf"
    },
    model: {
      value: (_vm.ffExoprtDetail.onAccountOf),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "onAccountOf", $$v)
      },
      expression: "ffExoprtDetail.onAccountOf"
    }
  })], 1)], 1)], 1) : _vm._e()], 1) : _vm._e()], 1)])], 1) : _vm._e(), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": _vm.ffExoprtDetail.mainEnquiryId != '' ? true : _vm.showFFCCAccordina,
      "id": "accordion-2",
      "accordion": "my-accordion2",
      "role": "tabpanel"
    }
  }, [_c('div', [_c('div', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "25",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "ffAc"
    }
  }, [_vm._v(_vm._s(_vm.newJobType.indexOf("CC") >= 0 || _vm.newJobType.indexOf("FF") >= 0 ?
    "FF Activity Type *" :
    "FF Activity Type"))]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.disbleEnquiry ||
        (_vm.ffExoprtDetail.shipmentType == '1' &&
          _vm.ffExoprtDetail.transportType == 'Export' &&
          _vm.ffExoprtDetail.multipleContainerType[0] == 'LCL Container'),
      "list": _vm.ffExoprtDetail.shipmentType == '1' ?
        _vm.containerInfoName :
        _vm.ffActivityAir,
      "option-value": "containerInfoVal",
      "option-text": "containerInfoText",
      "placeholder": "Select Activity Type"
    },
    model: {
      value: (_vm.ffExoprtDetail.containerInfo),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "containerInfo", $$v)
      },
      expression: "ffExoprtDetail.containerInfo"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.containerInfo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.containerInfoError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "25",
      "md-flex-small": "100"
    }
  }, [_c('label', [_vm._v("Estimated Date *")]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "100",
      "md-flex-small": "100"
    }
  }, [_c('date-picker', {
    attrs: {
      "width": "100%",
      "disabled": _vm.disbleEnquiry,
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "weighingDate",
      "id": "weighingDate"
    },
    model: {
      value: (_vm.ffExoprtDetail.estimatedDate),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "estimatedDate", $$v)
      },
      expression: "ffExoprtDetail.estimatedDate"
    }
  })], 1)], 1), _vm._v(" "), (_vm.ffExoprtDetail.shipmentType == '1') ? _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "stuffingType"
    }
  }, [_vm._v(_vm._s(_vm.newJobType.indexOf("CC") >= 0 || _vm.newJobType.indexOf("FF") >= 0 ?
    "Stuffing Type *" :
    "Stuffing Type"))]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.ffExoprtDetail.containerInfo == 'lcl' || _vm.disbleEnquiry ?
        true :
        false,
      "list": _vm.stuffingTypeName,
      "option-value": "stuffingTypeVal",
      "option-text": "stuffingTypeText",
      "placeholder": "Select Stuffing Type"
    },
    model: {
      value: (_vm.ffExoprtDetail.stuffingType),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "stuffingType", $$v)
      },
      expression: "ffExoprtDetail.stuffingType"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.stuffingType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.stuffingTypeError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "ffssd"
    }
  }, [_vm._v(_vm._s(_vm.newJobType.indexOf("CC") >= 0 || _vm.newJobType.indexOf("FF") >= 0 ?
    "Importer Name *" :
    "Importer Name"))]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.ffExoprtDetail.transportType == 'Import' || _vm.disbleEnquiry ?
        true :
        false,
      "list": _vm.getImporterExpo,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Importer Name"
    },
    on: {
      "input": _vm.showExpInput
    },
    model: {
      value: (_vm.ffExoprtDetail.importerClientId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "importerClientId", $$v)
      },
      expression: "ffExoprtDetail.importerClientId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.importerClientId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.importerClientIdError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "ffssxzxd"
    }
  }, [_vm._v(_vm._s(_vm.newJobType.indexOf("CC") >= 0 || _vm.newJobType.indexOf("FF") >= 0 ?
    "Exporter Name *" :
    "Exporter Name"))]), _vm._v(" "), (
    (_vm.ffExoprtDetail.transportType == 'Export' ||
      _vm.ffExoprtDetail.transportType == 'Import') &&
    (_vm.ffExoprtDetail.clientType == '2' ||
      _vm.ffExoprtDetail.clientType == '3' ||
      _vm.ffExoprtDetail.clientType == '4')
  ) ? _c('model-list-select', {
    staticClass: "ml-1",
    attrs: {
      "isDisabled": (_vm.ffExoprtDetail.transportType == 'Export' &&
          _vm.ffExoprtDetail.clientType == '2') ||
        _vm.disbleEnquiry ?
        true :
        false,
      "list": _vm.ffExoprtDetail.clientType == '2' ?
        _vm.$store.getters['common/getAllLeadCompList'] :
        (_vm.ffExoprtDetail.clientType == '3' || _vm.ffExoprtDetail.clientType == '4') ?
        _vm.getCLientData :
        _vm.$store.getters['common/getAllClientList'],
      "id": "clientNamenew",
      "option-value": _vm.ffExoprtDetail.clientType == '2' ? 'lead_id' : 'clientId',
      "option-text": _vm.ffExoprtDetail.clientType == '2' ?
        'lead_comp_name' :
        'clientName',
      "placeholder": "Select Exporter Name"
    },
    on: {
      "input": function($event) {
        _vm.pickUpExpClient($event);
        _vm.showExpInput
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.exporterClientId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "exporterClientId", $$v)
      },
      expression: "ffExoprtDetail.exporterClientId"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.ffExoprtDetail.exporterClientId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.exporterClientIdError))]) : _vm._e(), _vm._v(" "), (
    (_vm.ffExoprtDetail.transportType == 'Export' ||
      _vm.ffExoprtDetail.transportType == 'Import') &&
    _vm.ffExoprtDetail.clientType == '1'
  ) ? _c('model-list-select', {
    attrs: {
      "isDisabled": (_vm.ffExoprtDetail.transportType == 'Export' &&
          _vm.ffExoprtDetail.clientType == '1') ||
        _vm.disbleEnquiry ?
        true :
        false,
      "list": _vm.getImporterExpo,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Exporter Name"
    },
    model: {
      value: (_vm.ffExoprtDetail.exporterClientId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "exporterClientId", $$v)
      },
      expression: "ffExoprtDetail.exporterClientId"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.ffExoprtDetail.exporterClientId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.exporterClientIdError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [(_vm.openImpoInput == true) ? _c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Importer Name")]) : _vm._e(), _vm._v(" "), (_vm.openImpoInput == true) ? _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": _vm.disbleEnquiry,
      "id": "otherImpoName",
      "name": "otherImpoName"
    },
    model: {
      value: (_vm.ffExoprtDetail.otherImpoName),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "otherImpoName", $$v)
      },
      expression: "ffExoprtDetail.otherImpoName"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.openExpoInput == true) ? _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Exporter Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": _vm.disbleEnquiry,
      "id": "otherExpoName",
      "name": "otherExpoName"
    },
    model: {
      value: (_vm.ffExoprtDetail.otherExpoName),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "otherExpoName", $$v)
      },
      expression: "ffExoprtDetail.otherExpoName"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [(
    (_vm.ffExoprtDetail.transportType == 'Import' ||
      _vm.ffExoprtDetail.shipmentType == '1') &&
    _vm.hideCCSection == false &&
    _vm.ffExoprtDetail.PORFromTPT != ''
  ) ? _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "ffscxcsxzxd"
    }
  }, [_vm._v(_vm._s(_vm.newJobType.indexOf("CC") >= 0 || _vm.newJobType.indexOf("FF") >= 0 ?
    "Place of Receipt *" :
    "Place of Receipt"))]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": "",
      "name": "PORFromTPT",
      "id": "PORFromTPT"
    },
    model: {
      value: (_vm.ffExoprtDetail.PORFromTPT),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "PORFromTPT", $$v)
      },
      expression: "ffExoprtDetail.PORFromTPT"
    }
  })], 1) : _vm._e(), _vm._v(" "), (
    (_vm.ffExoprtDetail.transportType == 'Import' ||
      _vm.ffExoprtDetail.shipmentType == '1') &&
    _vm.hideCCSection == false &&
    _vm.ffExoprtDetail.PORFromTPT == ''
  ) ? _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "ffscxcsxzxd"
    }
  }, [_vm._v(_vm._s(_vm.newJobType.indexOf("CC") >= 0 || _vm.newJobType.indexOf("FF") >= 0 ?
    "Place of Receipt *" :
    "Place of Receipt"))]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.disbleEnquiry ||
        _vm.ffExoprtDetail.shipmentType == '' ||
        _vm.ffExoprtDetail.transportType == '',
      "list": _vm.IcdPOrtListNew,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Place of Receipt"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList(
          $event,
          _vm.ffExoprtDetail.shipmentType == '1' &&
          _vm.ffExoprtDetail.transportType == 'Export' ?
          'Icd,Sea_Port_India' :
          'Sea_Port_NonIndia',
          'IcdPOrtList'
        )
      },
      "searchchange": function($event) {
        _vm.getLocationList(
          $event,
          _vm.ffExoprtDetail.shipmentType == '1' &&
          _vm.ffExoprtDetail.transportType == 'Export' ?
          'Icd,Sea_Port_India' :
          'Sea_Port_NonIndia',
          'IcdPOrtList'
        )
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.PORlocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "PORlocationId", $$v)
      },
      expression: "ffExoprtDetail.PORlocationId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.PORlocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.PORlocationIdError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (
    _vm.ffExoprtDetail.shipmentType == '1' && _vm.hideFFSection == false
  ) ? _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": _vm.hideCCSection == false ? '50' : '40',
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "ffscxcsxzxd"
    }
  }, [_vm._v(_vm._s(_vm.newJobType.indexOf("FF") >= 0 ?
    "Load Port Name *" :
    "Load Port Name"))]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.disbleEnquiry ||
        _vm.ffExoprtDetail.shipmentType == '' ||
        _vm.ffExoprtDetail.transportType == '' ||
        _vm.ffExoprtDetail.multipleContainerType.length == 0,
      "list": _vm.PortLoadList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Load Port Name"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList(
          $event,
          _vm.ffExoprtDetail.shipmentType == '1' &&
          _vm.ffExoprtDetail.transportType == 'Export' ?
          'Sea_Port_India' :
          'Sea_Port_NonIndia',
          'PortLoadList'
        )
      },
      "searchchange": function($event) {
        _vm.getLocationList(
          $event,
          _vm.ffExoprtDetail.shipmentType == '1' &&
          _vm.ffExoprtDetail.transportType == 'Export' ?
          'Sea_Port_India' :
          'Sea_Port_NonIndia',
          'PortLoadList'
        )
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.LPlocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "LPlocationId", $$v)
      },
      expression: "ffExoprtDetail.LPlocationId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.LPlocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.LPlocationIdError))]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [(
    _vm.ffExoprtDetail.shipmentType == '1' && _vm.hideFFSection == false
  ) ? _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "ffscxcsxzxd"
    }
  }, [_vm._v(_vm._s(_vm.newJobType.indexOf("FF") >= 0 ?
    "Port of Discharge *" :
    "Port of Discharge"))]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.disbleEnquiry ||
        _vm.ffExoprtDetail.shipmentType == '' ||
        _vm.ffExoprtDetail.transportType == '' ||
        _vm.ffExoprtDetail.multipleContainerType.length == 0,
      "list": _vm.PortDischargeList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select POD"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList(
          $event,
          _vm.ffExoprtDetail.shipmentType == '1' &&
          _vm.ffExoprtDetail.transportType == 'Export' ?
          'Sea_Port_NonIndia' :
          'Sea_Port_India',
          'getPortDischargeList'
        )
      },
      "searchchange": function($event) {
        _vm.getLocationList(
          $event,
          _vm.ffExoprtDetail.shipmentType == '1' &&
          _vm.ffExoprtDetail.transportType == 'Export' ?
          'Sea_Port_NonIndia' :
          'Icd,Sea_Port_India',
          'getPortDischargeList'
        )
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.PODLocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "PODLocationId", $$v)
      },
      expression: "ffExoprtDetail.PODLocationId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.PODLocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.PODLocationIdError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (
    (_vm.ffExoprtDetail.transportType == 'Import' ||
      _vm.ffExoprtDetail.shipmentType == '1') &&
    _vm.hideFFSection == false
  ) ? _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "ffscxcsxzxd"
    }
  }, [_vm._v(_vm._s(_vm.newJobType.indexOf("FF") >= 0 ?
    "Final Place of Delivery *" :
    "Final Place of Delivery"))]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.disbleEnquiry ||
        _vm.ffExoprtDetail.shipmentType == '' ||
        _vm.ffExoprtDetail.transportType == '',
      "list": _vm.finalAllPlaceData,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select FPOD"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList(
          $event,
          _vm.ffExoprtDetail.shipmentType == '1' &&
          _vm.ffExoprtDetail.transportType == 'Export' ?
          'Sea_Port_NonIndia' :
          'Icd,Sea_Port_India',
          'finalAllPlaceData'
        )
      },
      "searchchange": function($event) {
        _vm.getLocationList(
          $event,
          _vm.ffExoprtDetail.shipmentType == '1' &&
          _vm.ffExoprtDetail.transportType == 'Export' ?
          'Sea_Port_NonIndia' :
          'Icd,Sea_Port_India',
          'finalAllPlaceData'
        )
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.finalPlaceLocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "finalPlaceLocationId", $$v)
      },
      expression: "ffExoprtDetail.finalPlaceLocationId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.finalPlaceLocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.finalPlaceLocationIdError))]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (
    _vm.ffExoprtDetail.shipmentType == '1' && _vm.hideFFSection == false
  ) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.ffExoprtDetail.shipmentType == '1') ? _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "shippingId"
    }
  }, [_vm._v("Shipping Line Name (Prefered)")]), _vm._v(" "), (
    _vm.ffExoprtDetail.shipmentType == '1' &&
    _vm.ffExoprtDetail.transportType == 'Export' &&
    _vm.ffExoprtDetail.multipleContainerType[0] ==
    'LCL Container' &&
    _vm.ffExoprtDetail.containerInfo == 'lcl'
  ) ? _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.disbleEnquiry ||
        !(
          _vm.ffExoprtDetail.shipmentType == '1' &&
          _vm.ffExoprtDetail.transportType == 'Export' &&
          _vm.ffExoprtDetail.multipleContainerType[0] ==
          'LCL Container' &&
          _vm.ffExoprtDetail.containerInfo == 'lcl'
        ) ?
        true :
        false,
      "list": _vm.getColoaderNameList,
      "option-value": "agntColoaderId",
      "option-text": "coLoaderName",
      "placeholder": "Select Shipping Line"
    },
    model: {
      value: (_vm.ffExoprtDetail.shippingId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "shippingId", $$v)
      },
      expression: "ffExoprtDetail.shippingId"
    }
  }) : _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.disbleEnquiry,
      "list": _vm.getShippingLineData,
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    model: {
      value: (_vm.ffExoprtDetail.shippingId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "shippingId", $$v)
      },
      expression: "ffExoprtDetail.shippingId"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "deliveryMode"
    }
  }, [_vm._v("Destination Delivery Mode")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.disbleEnquiry,
      "list": _vm.deliveryModeName,
      "option-value": "deliveryModeVal",
      "option-text": "deliveryModeText",
      "placeholder": "Select  Mode"
    },
    model: {
      value: (_vm.ffExoprtDetail.deliveryMode),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "deliveryMode", $$v)
      },
      expression: "ffExoprtDetail.deliveryMode"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "deliveryTerms"
    }
  }, [_vm._v("Delivery Terms(INCOTERMS)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.disbleEnquiry,
      "list": _vm.deliveryTermsName,
      "option-value": "deliveryTermsVal",
      "option-text": "deliveryTermsText",
      "placeholder": "Select Delivery Terms"
    },
    model: {
      value: (_vm.ffExoprtDetail.deliveryTerms),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "deliveryTerms", $$v)
      },
      expression: "ffExoprtDetail.deliveryTerms"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', [(
    _vm.ffExoprtDetail.shipmentType == '2' && _vm.hideFFSection == false
  ) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "PORlocationId"
    }
  }, [_vm._v("Airport of Departure (Handover)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.disbleEnquiry,
      "list": _vm.AirIcdPOrtList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Airport Departure"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'Air_Port', 'AirIcdPOrtList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Air_Port', 'AirIcdPOrtList')
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.airportDeparture),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "airportDeparture", $$v)
      },
      expression: "ffExoprtDetail.airportDeparture"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.airportDeparture) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.airportDepartureError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "LPlocationId"
    }
  }, [_vm._v("Airport of Destination")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.disbleEnquiry,
      "list": _vm.AirPortLoadList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Destination"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'Air_Port', 'AirPortLoadList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Air_Port', 'AirPortLoadList')
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.airportDestination),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "airportDestination", $$v)
      },
      expression: "ffExoprtDetail.airportDestination"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.airportDestination) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.airportDestinationError))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.ffExoprtDetail.shipmentType == '2') ? _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerTypeId"
    }
  }, [_vm._v("Airline (Prefered)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.disbleEnquiry,
      "list": _vm.airLineList,
      "option-value": "airlineId",
      "option-text": "airlineName",
      "placeholder": "Select Airline"
    },
    model: {
      value: (_vm.ffExoprtDetail.airlineId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "airlineId", $$v)
      },
      expression: "ffExoprtDetail.airlineId"
    }
  })], 1) : _vm._e(), _vm._v(" "), (
    _vm.ffExoprtDetail.shipmentType == '1' &&
    _vm.ffExoprtDetail.containerInfo == 'lcl'
  ) ? _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }) : _vm._e(), _vm._v(" "), (
    _vm.ffExoprtDetail.shipmentType == '1' &&
    _vm.ffExoprtDetail.containerInfo == 'lcl'
  ) ? _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "agentName"
    }
  }, [_vm._v("CoLoader Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.getColoaderNameList,
      "isDisabled": _vm.disbleEnquiry ||
        !(
          _vm.ffExoprtDetail.shipmentType == '1' &&
          _vm.ffExoprtDetail.transportType == 'Export' &&
          _vm.ffExoprtDetail.multipleContainerType[0] ==
          'LCL Container' &&
          _vm.ffExoprtDetail.containerInfo == 'lcl'
        ) ?
        true :
        false,
      "option-value": "agntColoaderId",
      "option-text": "coLoaderName",
      "placeholder": "Select Coloader Name"
    },
    on: {
      "input": function($event) {
        _vm.ColoderBasedShipppingLine(_vm.ffExoprtDetail.coLoaderId)
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.coLoaderId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "coLoaderId", $$v)
      },
      expression: "ffExoprtDetail.coLoaderId"
    }
  })], 1) : _vm._e(), _vm._v(" "), (
    _vm.ffExoprtDetail.shipmentType == '2' ||
    _vm.ffExoprtDetail.containerInfo == 'lcl'
  ) ? _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "15",
      "md-flex-small": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "noOfPkg"
    }
  }, [_vm._v("No. of Packages")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": _vm.disbleEnquiry,
      "id": "noOfPkg",
      "name": "noOfPkg",
      "type": "number"
    },
    model: {
      value: (_vm.ffExoprtDetail.noOfPkg),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "noOfPkg", $$v)
      },
      expression: "ffExoprtDetail.noOfPkg"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.ffExoprtDetail.shipmentType == '1' &&
    _vm.ffExoprtDetail.containerInfo == 'lcl'
  ) ? _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }) : _vm._e(), _vm._v(" "), (
    _vm.ffExoprtDetail.shipmentType == '1' &&
    _vm.ffExoprtDetail.containerInfo == 'lcl'
  ) ? _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('div', {
    staticClass: "row mt-3",
    staticStyle: {
      "display": "none"
    }
  }, [_c('b-form-radio', {
    attrs: {
      "disabled": _vm.disbleEnquiry,
      "name": "some-radios",
      "value": "Same"
    },
    model: {
      value: (_vm.ffExoprtDetail.selectedDimmen),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "selectedDimmen", $$v)
      },
      expression: "ffExoprtDetail.selectedDimmen"
    }
  }, [_vm._v("Same Dimension")]), _vm._v(" "), _c('b-form-radio', {
    attrs: {
      "disabled": _vm.disbleEnquiry,
      "name": "some-radios",
      "value": "Different"
    },
    model: {
      value: (_vm.ffExoprtDetail.selectedDimmen),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "selectedDimmen", $$v)
      },
      expression: "ffExoprtDetail.selectedDimmen"
    }
  }, [_vm._v("Different")])], 1)]) : _vm._e(), _vm._v(" "), (
    _vm.ffExoprtDetail.shipmentType == '2' ||
    _vm.ffExoprtDetail.containerInfo == 'lcl'
  ) ? _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "15",
      "md-flex-small": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "noOfPkg"
    }
  }, [_vm._v("Gross Wgt(Kg)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": _vm.disbleEnquiry,
      "id": "noOfPkg",
      "name": "noOfPkg",
      "type": "number"
    },
    model: {
      value: (_vm.ffExoprtDetail.lclGrossWgt),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "lclGrossWgt", $$v)
      },
      expression: "ffExoprtDetail.lclGrossWgt"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.ffExoprtDetail.shipmentType == '2' ||
    _vm.ffExoprtDetail.containerInfo == 'lcl'
  ) ? _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "20",
      "md-flex-small": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "grossVolWgt"
    }
  }, [_vm._v(_vm._s(_vm.ffExoprtDetail.shipmentType == "1" ?
    " Vol. Wgt.(In CBM)" :
    "Gross Volume Wgt."))]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": _vm.disbleEnquiry,
      "id": "grossVolWgt",
      "name": "grossVolWgt",
      "type": "number"
    },
    model: {
      value: (_vm.ffExoprtDetail.grossVolWgtAir),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "grossVolWgtAir", $$v)
      },
      expression: "ffExoprtDetail.grossVolWgtAir"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), (
    _vm.ffExoprtDetail.shipmentType == '1' &&
    _vm.ffExoprtDetail.containerInfo == 'lcl'
  ) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "noOfPkg"
    }
  }, [_vm._v("Net Wt ( in KG)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": _vm.disbleEnquiry,
      "id": "noOfPkg",
      "name": "noOfPkg",
      "type": "number"
    },
    model: {
      value: (_vm.ffExoprtDetail.lclNetWgt),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "lclNetWgt", $$v)
      },
      expression: "ffExoprtDetail.lclNetWgt"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.ffExoprtDetail.shipmentType == '2') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "PORlocationId"
    }
  }, [_vm._v("Cargo Received At")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "disabled": _vm.disbleEnquiry,
      "list": _vm.cargoReceivedList,
      "option-value": "val",
      "option-text": "type",
      "placeholder": "Select Cargo Received"
    },
    model: {
      value: (_vm.ffExoprtDetail.cargoReceived),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "cargoReceived", $$v)
      },
      expression: "ffExoprtDetail.cargoReceived"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.cargoReceived) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.cargoReceivedError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "20",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "LPlocationId"
    }
  }, [_vm._v("Destination Delivery Mode")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.disbleEnquiry,
      "list": _vm.destinationDelieveryList,
      "option-value": "val",
      "option-text": "type",
      "placeholder": "Select Destination"
    },
    model: {
      value: (_vm.ffExoprtDetail.destinationModeAir),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "destinationModeAir", $$v)
      },
      expression: "ffExoprtDetail.destinationModeAir"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.destinationModeAir) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.destinationModeAirError))]) : _vm._e()], 1), _vm._v(" "), (_vm.ffExoprtDetail.destinationModeAir == '2') ? _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "LPlocationId"
    }
  }, [_vm._v("FPOD")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.disbleEnquiry,
      "list": _vm.finalAllPlaceData,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Destination"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceData')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceData')
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.doorDestinationfpod),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "doorDestinationfpod", $$v)
      },
      expression: "ffExoprtDetail.doorDestinationfpod"
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (
    _vm.ffExoprtDetail.selectedCCQuotationId == '' &&
    _vm.ffExoprtDetail.shipmentType == '1'
  ) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "ccType"
    }
  }, [_vm._v("CC Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.disbleEnquiry,
      "list": _vm.cctypeList,
      "option-value": "ccTypeVal",
      "option-text": "ccTypeTxt",
      "placeholder": "Select CC Type"
    },
    model: {
      value: (_vm.ffExoprtDetail.ccType),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "ccType", $$v)
      },
      expression: "ffExoprtDetail.ccType"
    }
  })], 1), _vm._v(" "), (_vm.ffExoprtDetail.ccType == '2') ? _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("CHA Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "ccCha",
      "disabled": _vm.disbleEnquiry,
      "name": "ccCha"
    },
    model: {
      value: (_vm.ffExoprtDetail.ccCha),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "ccCha", $$v)
      },
      expression: "ffExoprtDetail.ccCha"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "otherComodity"
    }
  }, [_vm._v("Commodity Details")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": _vm.disbleEnquiry,
      "id": "otherComodity",
      "name": "otherComodity"
    },
    model: {
      value: (_vm.ffExoprtDetail.otherComodity),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "otherComodity", $$v)
      },
      expression: "ffExoprtDetail.otherComodity"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Remarks")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "remark",
      "name": "remark"
    },
    model: {
      value: (_vm.ffExoprtDetail.remark),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "remark", $$v)
      },
      expression: "ffExoprtDetail.remark"
    }
  })], 1)], 1)], 1)], 1)])]), _vm._v(" "), (
    _vm.ffExoprtDetail.tptEnquiry.length > 0 ||
    _vm.ffExoprtDetail.ffEnquiry.length > 0 ||
    _vm.ffExoprtDetail.ccEnquiry.length > 0
  ) ? _c('hr', {
    staticClass: "hr-s"
  }) : _vm._e(), _vm._v(" "), (_vm.ffExoprtDetail.tptEnquiry.length > 0) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.ffExoprtDetail.tptEnquiry[0].tptStatus == 1) ? _c('md-layout', {
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Client Approval (TPT)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.statusList,
      "option-value": "statusV",
      "option-text": "statusT",
      "placeholder": "Select Status",
      "isDisabled": _vm.ffExoprtDetail.tptStatus == '0' ? false : true
    },
    model: {
      value: (_vm.ffExoprtDetail.tptClientStatus),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "tptClientStatus", $$v)
      },
      expression: "ffExoprtDetail.tptClientStatus"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.ffExoprtDetail.ccEnquiry.length > 0) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.ffExoprtDetail.ccEnquiry[0].ccStatus == 1) ? _c('md-layout', {
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Client Approval (CC)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.statusList,
      "option-value": "statusV",
      "option-text": "statusT",
      "placeholder": "Select Status",
      "isDisabled": _vm.ffExoprtDetail.ccStatus == '0' ? false : true
    },
    model: {
      value: (_vm.ffExoprtDetail.ccClientStatus),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "ccClientStatus", $$v)
      },
      expression: "ffExoprtDetail.ccClientStatus"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.ffExoprtDetail.ffEnquiry.length > 0) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.ffExoprtDetail.ffEnquiry[0].ffStatusManager == 1) ? _c('md-layout', {
    attrs: {
      "md-flex": "50",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Client Approval (FF)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.statusList,
      "option-value": "statusV",
      "option-text": "statusT",
      "placeholder": "Select Status",
      "isDisabled": _vm.ffExoprtDetail.ffStatus == '0' ? false : true
    },
    model: {
      value: (_vm.ffExoprtDetail.ffClientStatus),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "ffClientStatus", $$v)
      },
      expression: "ffExoprtDetail.ffClientStatus"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.ffExoprtDetail.ffClientStatus == '1') ? _c('md-layout', {
    attrs: {
      "md-flex": "45",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "ffShippingWiseId"
    }
  }, [_vm._v("Approved\n                  " + _vm._s(_vm.ffExoprtDetail.shipmentType == "1" &&
    _vm.ffExoprtDetail.containerInfo == "lcl" ?
    "Co Loader" :
    _vm.ffExoprtDetail.shipmentType == "1" ?
    "Shipping Line" :
    "Airline") + "\n                  By Client")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.ffShippingArray,
      "option-value": "ffShippingWiseId",
      "option-text": _vm.ffExoprtDetail.shipmentType == '1' &&
        _vm.ffExoprtDetail.containerInfo == 'lcl' ?
        'coLoaderName' :
        _vm.ffExoprtDetail.shipmentType == '1' ?
        'shippingLine' :
        'airlineName',
      "placeholder": _vm.ffExoprtDetail.shipmentType == '1' &&
        _vm.ffExoprtDetail.containerInfo == 'lcl' ?
        'Select Coloader' :
        _vm.ffExoprtDetail.shipmentType == '1' ?
        'shippingLine' :
        ' Select Airline',
      "isDisabled": _vm.ffExoprtDetail.ffStatus == '0' ? false : true
    },
    model: {
      value: (_vm.ffExoprtDetail.ffShippingWiseId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "ffShippingWiseId", $$v)
      },
      expression: "ffExoprtDetail.ffShippingWiseId"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.allModuleIdNew == '' || _vm.allModuleIdNew == null) ? _c('md-layout', {
    staticClass: "justify-content-center mt-3",
    attrs: {
      "md-flex-small": "100",
      "md-gutter": ""
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.onCloseSubmit
    }
  }, [_vm._v("Save & Submit")]), _vm._v(" "), (_vm.showQuoteButton == true) ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.showExistQuote
    }
  }, [_vm._v("Show Existing Quotes")]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [(_vm.ffExoprtDetail.EnquiryCreated) ? _c('span', {
    staticClass: "error pull-right"
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.ffExoprtDetail.EnquiryCreated))])]) : _vm._e()]), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [(_vm.ffExoprtDetail.EnquiryUpdated) ? _c('span', {
    staticClass: "error pull-right"
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.ffExoprtDetail.EnquiryUpdated))])]) : _vm._e()])], 1)])], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "QuotePop",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "scrollable": "",
      "id": "myDIV",
      "hide-footer": "",
      "title": "Valid Existing Quotations"
    }
  }, [_c('div', {
    staticClass: "d-block text-center"
  }, [_c('b-card', [_c('b-card-text', [_c('div', [_c('div', [_c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.closeDialogQuote
    }
  }, [_vm._v("Cancel & Close")]), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right",
    staticStyle: {
      "margin": "left:5px"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.closeDialogQuoteSave
    }
  }, [_vm._v("Save")])], 1), _vm._v(" "), _c('b-tabs', {
    attrs: {
      "content-class": "mt-3"
    }
  }, [_c('b-tab', {
    attrs: {
      "disabled": ""
    }
  }), _vm._v(" "), (_vm.newJobType.indexOf('FF') >= 0 && _vm.allFFDataTable.length > 0) ? _c('b-tab', {
    attrs: {
      "title": "Existing Freight Quotation",
      "active": ""
    }
  }, [(_vm.newJobType.indexOf('FF') >= 0 && _vm.allFFDataTable.length > 0) ? _c('div', [_c('table', {
    staticClass: "table gutr",
    attrs: {
      "id": "FFTable"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr.No.")]), _vm._v(" "), _c('th', [_vm._v("FF Quotation Details")]), _vm._v(" "), (_vm.ffExoprtDetail.shipmentType == '1') ? _c('th', [_vm._v("\n                            Container Type\n                          ")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Quotation No & Validity")]), _vm._v(" "), _c('th', [_vm._v("Quote PDF")]), _vm._v(" "), _c('th', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.clearFFRadio
    }
  }, [_vm._v("Clear Selected FF Quote")])], 1)])]), _vm._v(" "), _c('tbody', _vm._l((_vm.allFFDataTable), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('b', {
      staticClass: "error"
    }, [_vm._v("FF Type :")]), _vm._v(" "), _c('b', {
      staticClass: "error"
    }, [_vm._v(_vm._s(item1.transportType))]), _vm._v(" "), (_vm.ffExoprtDetail.shipmentType == '1') ? _c('div', [_c('b', [_vm._v("Shipping Line :")]), _vm._v("\n                              " + _vm._s(item1.ApprovedSLine) + "\n                              "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Place of Receipt :")]), _vm._v("\n                              " + _vm._s(item1.POR) + "\n                              "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Load Port :")]), _vm._v("\n                              " + _vm._s(item1.LP) + "\n                              "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Port of Discharge :")]), _vm._v("\n                              " + _vm._s(item1.POD) + "\n                              "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Final Place of Delivery :")]), _vm._v("\n                              " + _vm._s(item1.finalPlace) + "\n                            ")]) : _c('div', [_c('br'), _vm._v(" "), _c('b', [_vm._v("Departure Airport :")]), _vm._v("\n                              " + _vm._s(item1.departPort) + "\n                              "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Destination Airport :")]), _vm._v("\n                              " + _vm._s(item1.destiPort) + "\n                            ")])]), _vm._v(" "), (_vm.ffExoprtDetail.shipmentType == '1') ? _c('td', [_vm._v("\n                            " + _vm._s(item1.multipleContainerType) + "\n                            ")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(item1.mainFFSeries) + "\n                            "), _c('br'), _vm._v("\n                            " + _vm._s(_vm._f("moment")(item1.ffvalidityDate)) + "\n                            "), _c('br'), _vm._v(" "), (item1.ffvalidityDate < item1.currDate) ? _c('b-badge', {
      attrs: {
        "variant": "success"
      }
    }, [_vm._v("Quote Expired")]) : _vm._e()], 1), _vm._v(" "), _c('td', [(
      item1.ffQuotationPdf != '' &&
      item1.ffQuotationPdf != null
    ) ? _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "outline-success"
      },
      on: {
        "click": function($event) {
          _vm.PrintFF(item1.ffQuotationPdf)
        }
      }
    }, [_c('md-icon', [_vm._v("print")])], 1) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('md-radio', {
      staticClass: "md-primary",
      attrs: {
        "id": item1.mainffId,
        "name": "my-test-group2",
        "md-value": item1.mainffId
      },
      on: {
        "change": function($event) {
          _vm.selectedFFQuotation(
            item1.mainffId,
            item1.mainEnquiryId,
            item1
          )
        }
      },
      model: {
        value: (_vm.selectedFFRadio),
        callback: function($$v) {
          _vm.selectedFFRadio = $$v
        },
        expression: "selectedFFRadio"
      }
    }, [_vm._v("Select")])], 1)])
  }))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.newJobType.indexOf('CC') >= 0 && _vm.allCCDataTable.length > 0) ? _c('b-tab', {
    attrs: {
      "title": "Existing Custom Quotation"
    }
  }, [(_vm.newJobType.indexOf('CC') >= 0 && _vm.allCCDataTable.length > 0) ? _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "id": "CCTable"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr.No.")]), _vm._v(" "), _c('th', [_vm._v("CC Quotation Details")]), _vm._v(" "), _c('th', [_vm._v("Container Type")]), _vm._v(" "), _c('th', [_vm._v("Quote No. & Validity")]), _vm._v(" "), _c('th', [_vm._v("Quote PDF")]), _vm._v(" "), _c('th', [_c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.clearCCRadio
    }
  }, [_vm._v("Clear Selected CC Quote")])], 1)])]), _vm._v(" "), _c('tbody', _vm._l((_vm.allCCDataTable), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('b', {
      staticClass: "error"
    }, [_vm._v("CC Type :")]), _vm._v(" "), _c('b', {
      staticClass: "error"
    }, [_vm._v(_vm._s(item1.transportType))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Place of Receipt :")]), _vm._v("\n                            " + _vm._s(item1.POR) + "\n                            "), _c('br'), _vm._v(" "), (item1.jobType.split(',').includes('FF')) ? _c('div', [_c('b', [_vm._v("Load Port :")]), _vm._v("\n                              " + _vm._s(item1.LP) + "\n                              "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Port of Discharge :")]), _vm._v("\n                              " + _vm._s(item1.POD) + "\n                              "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Final Place of Delivery :")]), _vm._v("\n                              " + _vm._s(item1.finalPlace) + "\n                            ")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(item1.multipleContainerType) + "\n                            ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(item1.ccQSeries) + "\n                            "), _c('br'), _vm._v("\n                            " + _vm._s(_vm._f("moment")(item1.validityDate)) + "\n                            "), _c('br'), _vm._v(" "), (item1.validityDate < item1.currDate) ? _c('b-badge', {
      attrs: {
        "variant": "success"
      }
    }, [_vm._v("Quote Expired")]) : _vm._e()], 1), _vm._v(" "), _c('td', [(
      item1.ccQuotationPdf != '' &&
      item1.ccQuotationPdf != null
    ) ? _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "outline-success"
      },
      on: {
        "click": function($event) {
          _vm.PrintCC(item1.ccQuotationPdf)
        }
      }
    }, [_c('md-icon', [_vm._v("print")])], 1) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('md-radio', {
      staticClass: "md-primary",
      attrs: {
        "id": item1.ccQId,
        "name": "my-test-group2",
        "md-value": item1.ccQId
      },
      on: {
        "change": function($event) {
          _vm.selectedCCQuotation(
            item1.ccQId,
            item1.mainEnquiryId,
            item1
          )
        }
      },
      model: {
        value: (_vm.selectedCCRadio),
        callback: function($$v) {
          _vm.selectedCCRadio = $$v
        },
        expression: "selectedCCRadio"
      }
    }, [_vm._v("Select")])], 1)])
  }))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.newJobType.indexOf('TPT') >= 0 && _vm.allTPTDataTable.length > 0) ? _c('b-tab', {
    attrs: {
      "title": "Existing Transport Quotation"
    }
  }, [(_vm.newJobType.indexOf('TPT') >= 0 && _vm.allTPTDataTable.length > 0) ? _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "id": "TPTTable"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr.No.")]), _vm._v(" "), _c('th', [_vm._v("TPT Quotation Details.")]), _vm._v(" "), _c('th', [_vm._v("Container Type")]), _vm._v(" "), _c('th', [_vm._v("Quotation No. & Validity")]), _vm._v(" "), _c('th', [_vm._v("Quote PDF")]), _vm._v(" "), _c('th', [_c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.clearTPTRadio
    }
  }, [_vm._v("Clear Selected TPT Quote")])], 1)])]), _vm._v(" "), _c('tbody', _vm._l((_vm.allTPTDataTable), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('b', {
      staticClass: "error"
    }, [_vm._v("TPT Type :")]), _vm._v(" "), _c('b', {
      staticClass: "error"
    }, [_vm._v(_vm._s(item1.transportType))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Pickup :")]), _vm._v("\n                            " + _vm._s(item1.pickUp) + "\n                            "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Factory :")]), _vm._v("\n                            " + _vm._s(item1.factoryLoc) + "\n                            "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Handover :")]), _vm._v("\n                            " + _vm._s(item1.handover) + "\n                          ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(item1.multipleContainerType) + "\n                            ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(item1.tptQSeries) + "\n                            "), _c('br'), _vm._v("\n                            " + _vm._s(_vm._f("moment")(item1.validityDate)) + "\n                            "), _c('br'), _vm._v(" "), (item1.validityDate < item1.currDate) ? _c('b-badge', {
      attrs: {
        "variant": "success"
      }
    }, [_vm._v("Quote Expired")]) : _vm._e()], 1), _vm._v(" "), _c('td', [(
      item1.tptQuotationPdf != '' &&
      item1.tptQuotationPdf != null
    ) ? _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "outline-success"
      },
      on: {
        "click": function($event) {
          _vm.PrintTPT(item1.tptQuotationPdf)
        }
      }
    }, [_c('md-icon', [_vm._v("print")])], 1) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('md-radio', {
      staticClass: "md-primary",
      attrs: {
        "id": item1.tptQId,
        "name": "my-test-group2",
        "md-value": item1.tptQId
      },
      on: {
        "change": function($event) {
          _vm.selectedTPTQuotation(
            item1.tptQId,
            item1.mainEnquiryId,
            item1
          )
        }
      },
      model: {
        value: (_vm.selectedTPTRadio),
        callback: function($$v) {
          _vm.selectedTPTRadio = $$v
        },
        expression: "selectedTPTRadio"
      }
    }, [_vm._v("Select")])], 1)])
  }))])]) : _vm._e()]) : _vm._e()], 1)], 1)])], 1)], 1), _vm._v(" "), _c('div', [_c('b-button', {
    staticClass: "mt-3 pull-right",
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.closeDialogQuote
    }
  }, [_vm._v("Cancel & Close")]), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3 pull-right",
    staticStyle: {
      "margin": "left:5px"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.closeDialogQuoteSave
    }
  }, [_vm._v("Save")])], 1)])], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop22",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAddFF
    }
  }), _vm._v(" "), _c('md-snackbar', {
    ref: "snackbar",
    attrs: {
      "md-position": _vm.vertical + ' ' + _vm.horizontal,
      "md-duration": _vm.duration
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.snackbarData))])]), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "dialog5",
    attrs: {
      "md-title": _vm.confirm.title,
      "md-content-html": _vm.confirm.contentHtml,
      "md-ok-text": _vm.confirm.ok,
      "md-cancel-text": _vm.confirm.cancel
    },
    on: {
      "close": _vm.onCloseSubmit
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69c2c23c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/allModuleForm/mainEnquiry.vue
// module id = 2708
// module chunks = 0